import { Routes } from '@angular/router';

import { WidgetAuthorizedGuard } from '@guards/widget-authorized.guard';
import { authGuard } from '@guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('@modules/common/common.module').then(m => m.CommonModule),
  },
  // {
  //   path: 'auth',
  //   canActivate: [authGuard],
  //   data: { authMode: 'guestOnly' },
  //   loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  // },
  {
    path: 'widgets/:id',
    canActivate: [WidgetAuthorizedGuard],
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    data: { authMode: 'requireUser' },
    loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule),
  },
  {
    path: 'call',
    canActivate: [authGuard],
    data: { authMode: 'requireUser' },
    loadChildren: () => import('./modules/call/call.module').then(m => m.CallModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
